/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseHeaderBlock } from './DatabaseHeaderBlock';
import {
    DatabaseHeaderBlockFromJSON,
    DatabaseHeaderBlockFromJSONTyped,
    DatabaseHeaderBlockToJSON,
} from './DatabaseHeaderBlock';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseFileHeaderBlock
 */
export interface DatabaseFileHeaderBlock extends DatabaseHeaderBlock {
    /**
     * Contains the ID of a library file
     * @type {string}
     * @memberof DatabaseFileHeaderBlock
     */
    content?: string;
}

/**
 * Check if a given object implements the DatabaseFileHeaderBlock interface.
 */
export function instanceOfDatabaseFileHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseFileHeaderBlockFromJSON(json: any): DatabaseFileHeaderBlock {
    return DatabaseFileHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseFileHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFileHeaderBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseHeaderBlockFromJSONTyped(json, ignoreDiscriminator),
        'content': !exists(json, 'content') ? undefined : json['content'],
    };
}

export function DatabaseFileHeaderBlockToJSON(value?: DatabaseFileHeaderBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseHeaderBlockToJSON(value),
        'content': value.content,
    };
}

